<script setup>
    const props = defineProps({
        label: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: true
        }
    })
</script>
<template>
    <dl>
        <dt class="text-xs text-gray-400">{{ label }}</dt>
        <dd v-html="value"></dd>
    </dl>
</template>
